import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
export const ButtonWithIcon = (props) => {
    const { text, iconName, iconPosition, loading = false, onClick } = props;
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        iconPosition === 'start' && (React.createElement(Button, { startIcon: React.createElement(Icon, null, iconName), disabled: loading, onClick: onClick }, loading ? React.createElement(CircularProgress, { size: 20 }) : t(text))),
        iconPosition === 'end' && (React.createElement(Button, { endIcon: React.createElement(Icon, null, iconName), disabled: loading, onClick: onClick }, loading ? React.createElement(CircularProgress, { size: 20 }) : t(text)))));
};
